export const VIDEO_POSITIONS = {
    LEFT: 'left',
    RIGHT: 'right',
} as const;

export type VIDEO_POSITION = typeof VIDEO_POSITIONS[keyof typeof VIDEO_POSITIONS];